<div id="crm-additional-team-member-form" *ngIf="readOnly; else formField">
  <div class="crm-field-label">{{ 'CRM.CUSTOM_INPUT.TEAM_MEMBERS' | translate }}</div>
  <div class="crm-field-value">
    <ng-container *ngIf="teamMembers() as teamMembers; else loading">
      <ng-container *ngIf="teamMembers !== NO_VALUE_FOR_TEAM_MEMBER">
        <div>
          <div class="tags">
            <glxy-badge [glxyTooltip]="teamMemberNames().join(', ')">{{ teamMemberNames()[0] }}</glxy-badge>
            <glxy-badge *ngIf="teamMemberNames().length === 2" [glxyTooltip]="teamMemberNames().join(', ')">
              {{ teamMemberNames()[1] }}
            </glxy-badge>
            <glxy-badge *ngIf="teamMemberNames().length > 2" [glxyTooltip]="teamMemberNames().join(', ')">
              +{{ teamMemberNames().length - 1 }}
            </glxy-badge>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #loading>
      <div class="stencil-shimmer"></div>
    </ng-template>
  </div>
</div>
<ng-template #formField>
  <glxy-form-field>
    <glxy-label>{{ 'CRM.CUSTOM_INPUT.TEAM_MEMBERS' | translate }}</glxy-label>
    <mat-chip-grid [disabled]="loadingValues()" #teamMemberGrid aria-label="Team member selection">
      <ng-container *ngIf="loadingValues(); else loadedChips">
        <mat-spinner [diameter]="24"></mat-spinner>
      </ng-container>
      <ng-template #loadedChips>
        <mat-chip-row
          *ngFor="let teamMember of selectedTeamMembers()"
          (removed)="remove(teamMember.userId); saveField()"
        >
          {{ teamMember.displayName }}
          <button matChipRemove [attr.aria-label]="'remove ' + teamMember.displayName">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      </ng-template>
      <input
        matInput
        #teamMemberInput
        [placeholder]="'Select...'"
        [formControl]="searchControl"
        [matChipInputFor]="teamMemberGrid"
        [matAutocomplete]="auto"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="false"
        (matChipInputTokenEnd)="add($event)"
        (blur)="saveField()"
        data-testid="filter-additional-team-member-input"
      />
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      <mat-option
        *ngFor="let option of filteredOptions()"
        [value]="option?.userId"
        (mousedown)="$event.preventDefault()"
      >
        {{ option?.displayName }}
      </mat-option>
    </mat-autocomplete>
    @if (formGroup.errors?.additionalTeamMemberIsOwner) {
      <glxy-error>
        {{ 'CRM.FORMS.OWNER_IN_ADDITIONAL_TEAM_MEMBERS' | translate }}
      </glxy-error>
    }
  </glxy-form-field>
</ng-template>
